import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { ContactMethod } from "../types";

interface ContactMethodCardProps {
  method: ContactMethod;
  onSelect: (method: ContactMethod) => void;
}

const ContactMethodCard = ({ method, onSelect }: ContactMethodCardProps) => {
  return (
    <div
      className={`relative p-6 rounded-lg border transition-all duration-300 hover:shadow-elevation-2 ${
        method.isPrimary
          ? "border-primary bg-primary/5" :"border-border bg-surface hover:border-primary/50"
      }`}
    >
      {method.isPrimary && (
        <div className="absolute -top-3 left-4 px-3 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
          Recommended
        </div>
      )}

      <div className="flex items-start gap-4">
        <div
          className={`p-3 rounded-lg ${
            method.isPrimary ? "bg-primary/10" : "bg-muted"
          }`}
        >
          <Icon
            name={method.icon}
            size={24}
            color={method.isPrimary ? "var(--color-primary)" : "var(--color-foreground)"}
          />
        </div>

        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">
            {method.name}
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            {method.description}
          </p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
            <Icon name="Clock" size={14} />
            <span>Response time: {method.responseTime}</span>
          </div>

          <Button
            variant={method.isPrimary ? "default" : "outline"}
            size="sm"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => onSelect(method)}
            className="w-full sm:w-auto"
          >
            Connect via {method.name}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactMethodCard;